import { isNil } from 'lodash';
import { MaybeNil } from '../../utils/interfaces';

export const generateTransientAnalysisId = (suffix: string) => {
  if (isScratchpadAnalysisId(suffix)) {
    // special case for top paths in scratchpad, scratchpad prefix needs to be before
    // the transient prefix.
    const baseId = parseAnalysisId(suffix);
    return generateTransientScratchpadAnalysisId(`transient:${baseId}`);
  }
  return `transient:${suffix}`;
};
export const isTransientAnalysisId = (id: MaybeNil<string>) =>
  !isNil(id) && id.startsWith('transient:');

export const generateTransientScratchpadAnalysisId = (analysisId: string) =>
  `scratchpad:${analysisId}`;
export const isScratchpadAnalysisId = (id: MaybeNil<string>) =>
  !isNil(id) && id.startsWith('scratchpad:');
export const generateScratchpadAnalysisId = (analysisId: string) =>
  generateTransientScratchpadAnalysisId(analysisId);

/**
 * Parses the analysis id from the transient analysis id.
 * This is needed because there are certain analysis id is
 *  stored in the store with the transient prefix.
 * For Scratchpad and Top Paths
 * @param id - The transient or analysis id.
 * @returns The analysis id.
 */
export const parseAnalysisId = (id: string): string => {
  if (id.startsWith('scratchpad:')) {
    return id.split('scratchpad:')[1];
  }

  if (id.startsWith('transient:')) {
    return id.split('transient:')[1];
  }

  return id;
};
